import HttpService from "@/utils/httpData"

export const saveFolderExcerciseClassSchool = params => {
    let apiEndpoint = `FolderExcerciseClassSchool/Create`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const listFolderExcerciseClassSchool = params => {
    let apiEndpoint = `FolderExcerciseClassSchool/List`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getDetail = id => {
    let apiEndpoint = `FolderExcerciseClassSchool/detail?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const deleteFolderExcerciseClassSchool = id => {
    let apiEndpoint = `FolderExcerciseClassSchool/Delete?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const changeOrderChapter = params => {
    let apiEndpoint = `FolderExcerciseClassSchool/ChangeOrderChapter`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const addListExcerciseToFolder = params => {
    let apiEndpoint = `FolderExcerciseClassSchool/AddListExcerciseToFolder`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const moveAllOutFolder = params => {
    let apiEndpoint = `FolderExcerciseClassSchool/MoveAllOutFolder`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const changeOrderFolder = params => {
    let apiEndpoint = `FolderExcerciseClassSchool/ChangeOrderFolder`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
